import { ChangeDetectionStrategy, Component, effect, signal, WritableSignal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { form, required } from '@angular/forms/signals';
import { MobileNumberDto } from '@workspace/data-types';
import { AbstractSignalFormComponent } from '../../../../abstract';
import { PhoneNumberInputComponent } from '../../../../inputs/phone/phone-number-input/phone-number-input.component';

export interface ContactInfosPhoneModel {
  mobileNumber: string;
}

@Component({
  selector: 'aura-contact-infos-phone-form',
  templateUrl: './contact-infos-phone-form.component.html',
  imports: [PhoneNumberInputComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuraContactInfosFormComponent extends AbstractSignalFormComponent<
  MobileNumberDto,
  ContactInfosPhoneModel
> {
  phoneControl = new FormControl<string | null>('');

  override model: WritableSignal<ContactInfosPhoneModel> = signal<ContactInfosPhoneModel>({
    mobileNumber: '',
  });

  override formTree = form(this.model, (b) => {
    required(b.mobileNumber);
  });

  constructor() {
    super();
    effect(() => {
      const current = this.model().mobileNumber;
      if (this.phoneControl.value !== current) {
        this.phoneControl.setValue(current || null, { emitEvent: false });
      }
    });
  }

  onNumberChanged(newNumber: string) {
    this.model.set({ mobileNumber: newNumber });
  }

  protected override buildModelFromDto(dto: MobileNumberDto): ContactInfosPhoneModel {
    return {
      mobileNumber: dto?.mobileNumber ?? '',
    };
  }

  protected override buildDtoFromModel(model: ContactInfosPhoneModel): MobileNumberDto {
    return {
      mobileNumber: model.mobileNumber,
    };
  }
}
